module.exports = __webpack_public_path__ + "img/level6.1187c183.png";